"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import { displayDate, isBeforeToday } from "@repo/design-system/utils/date-helpers";
import { combineEmploymentTypes } from "@repo/design-system/utils/helpers";
import { formatSalaryRow, getSalaryState } from "@repo/design-system/utils/salary-display";
import type { ReactNode } from "react";
import { useState } from "react";
import PrivacyNotice from "~/components/job-page/jobadtemplate/privacy-notice-eon";
import { LocationDisplay } from "~/components/ui/location-display-eon";
import { PrintDropdown } from "~/components/ui/print-dropdown-eon";
import ShareDropdown from "~/components/ui/share-dropdown-eon";
import { WatchJobButton } from "~/components/ui/watch-job-button-eon";
import { toSimilarJob } from "~/lib/utils/to-similar-job";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import KununuBoxEonGridsolutions from "./kununu-box-eon-gridsolutions";
export default function JobAdTemplateEonGridsolutions(t0) {
  const $ = _c(63);
  const {
    job
  } = t0;
  const t = useLanguage();
  const data = job.data;
  const displayLocale = t.i18n === "de" ? "de" : "en";
  let t1;
  if ($[0] !== data.applicationEnd) {
    t1 = data.applicationEnd && !isBeforeToday(data.applicationEnd);
    $[0] = data.applicationEnd;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showDeadline = t1;
  let t2;
  if ($[2] !== data.applicationEnd || $[3] !== displayLocale || $[4] !== t) {
    t2 = data.applicationEnd ? displayDate(data.applicationEnd.slice(0, 10), t, displayLocale) : null;
    $[2] = data.applicationEnd;
    $[3] = displayLocale;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const deadline = t2;
  let t3;
  if ($[6] !== job.content.compensationObject || $[7] !== t) {
    const salaryState = getSalaryState(job.content.compensationObject);
    t3 = formatSalaryRow(salaryState, t, t.i18n);
    $[6] = job.content.compensationObject;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const salaryRow = t3;
  let t4;
  if ($[9] !== data.title) {
    t4 = <h2 className="mb-4 font-bold text-4xl text-primary md:text-5xl" data-source="job">{data.title}</h2>;
    $[9] = data.title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = !data.locations || data.locations.length === 1 ? `${t.jobad_locationDisplay_single}: ` : `${t.jobad_locationDisplay_multi}: `;
  let t6;
  if ($[11] !== t5) {
    t6 = <span className="font-medium" data-source="lc">{t5}</span>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== job) {
    t7 = <LocationDisplay job={job} showAll={true} />;
    $[13] = job;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="mb-10 text-lg">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t10;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("grid-cols-2 gap-x-24 text-foreground text-xl md:text-lg lg:grid xl:gap-x-32", "print:break-inside-auto print:text-black", "[&_p+p]:mt-4", "[&_p:not(li>p)]:mb-4 [&_p:not(li>p)]:print:my-0 [&_p:not(li>p)]:print:mb-0 [&_p:not(li>p)]:print:p-0", "[&_h1]:mb-4 [&_h1]:print:my-0 [&_h1]:print:mb-0 [&_h1]:print:p-0", "[&_h2]:mb-4 [&_h2]:print:my-0 [&_h2]:print:mb-0 [&_h2]:print:p-0", "[&_h3]:mb-4 [&_h3]:print:my-0 [&_h3]:print:mb-0 [&_h3]:print:p-0", "[&_li]:mb-1.5", "[&_ul]:mt-4 [&_ul]:mb-8 [&_ul]:ml-6 [&_ul]:list-disc [&_ul]:print:my-0 [&_ul]:print:py-0", "overflow-wrap-break-word");
    t10 = {
      gridTemplateColumns: "minmax(0, 1fr) 400px"
    };
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  let t11;
  if ($[20] !== t.jobad_description_HL) {
    t11 = <h3 className="sr-only" data-source="lc">{t.jobad_description_HL}</h3>;
    $[20] = t.jobad_description_HL;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== job.content.task || $[23] !== job.content.taskHL) {
    t12 = job.content.task && <ContentBlock html={job.content.task} title={job.content.taskHL} />;
    $[22] = job.content.task;
    $[23] = job.content.taskHL;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== job.content.profile || $[26] !== job.content.profileHL) {
    t13 = job.content.profile && <ContentBlock html={job.content.profile} title={job.content.profileHL} />;
    $[25] = job.content.profile;
    $[26] = job.content.profileHL;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== job.content.offer || $[29] !== job.content.offerHL) {
    t14 = job.content.offer && <ContentBlock html={job.content.offer} title={job.content.offerHL} />;
    $[28] = job.content.offer;
    $[29] = job.content.offerHL;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <InclusionSection />;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t14) {
    t16 = <div className="overflow-wrap-break-word">{t11}{t12}{t13}{t14}{t15}</div>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const t17 = !!showDeadline;
  let t18;
  if ($[37] !== data || $[38] !== deadline || $[39] !== salaryRow || $[40] !== t17) {
    t18 = <DetailsBox data={data} deadline={deadline} salaryRow={salaryRow} showDeadline={t17} />;
    $[37] = data;
    $[38] = deadline;
    $[39] = salaryRow;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== data) {
    t19 = toSimilarJob(data);
    $[42] = data;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t19) {
    t20 = <WatchJobButton jobData={t19} variant="purple" />;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== job) {
    t21 = <ShareDropdown job={job} variant="purple" />;
    $[46] = job;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <PrintDropdown asButton={true} variant="purple" />;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t20 || $[50] !== t21) {
    t23 = <section className="grid h-10 grid-flow-col grid-cols-3 gap-4">{t20}{t21}{t22}</section>;
    $[49] = t20;
    $[50] = t21;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <KununuBoxEonGridsolutions />;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t18 || $[54] !== t23) {
    t25 = <div className="flex flex-col">{t18}{t23}{t24}</div>;
    $[53] = t18;
    $[54] = t23;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t16 || $[57] !== t25) {
    t26 = <div className={t9} style={t10}>{t16}{t25}</div>;
    $[56] = t16;
    $[57] = t25;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] !== t26 || $[60] !== t4 || $[61] !== t8) {
    t27 = <section className="outer-container py-container focus:outline-none print:hidden" id="job" tabIndex={-1}><div className="inner-container">{t4}{t8}{t26}</div></section>;
    $[59] = t26;
    $[60] = t4;
    $[61] = t8;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  return t27;
}
function ContentBlock(t0) {
  const $ = _c(7);
  const {
    html,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = title && <h3 className="font-bold" data-source="job">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== html) {
    t2 = <div dangerouslySetInnerHTML={{
      __html: html
    }} data-source="job" />;
    $[2] = html;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="pt-6">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function InclusionSection() {
  const $ = _c(32);
  const t = useLanguage();
  const [isEnglish, setIsEnglish] = useState(false);
  const source = isEnglish ? "text" : "lc";
  const t0 = isEnglish ? "Inclusion" : t.jobad_inclusionHL;
  let t1;
  if ($[0] !== source || $[1] !== t0) {
    t1 = <p className="mt-12 h-full font-bold" data-source={source}>{t0}</p>;
    $[0] = source;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="mr-3 text-sm" data-source="text">Show in English</p>;
    t3 = <span className="text-gray-400" data-source="text">OFF</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const t4 = isEnglish ? "bg-green-200" : "bg-gray-200";
  let t5;
  if ($[5] !== t4) {
    t5 = cn(t4, "relative inline-block h-4 w-10 cursor-pointer rounded-full");
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsEnglish(_temp);
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isEnglish) {
    t7 = <input checked={isEnglish} className="hidden" onChange={t6} type="checkbox" />;
    $[8] = isEnglish;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = isEnglish && "translate-x-6 bg-green-500";
  let t9;
  if ($[10] !== t8) {
    t9 = cn(t8, "absolute block h-4 w-4 rounded-full bg-gray-400 transition-transform");
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <span className={t9} />;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t5 || $[16] !== t7) {
    t11 = <label className={t5}>{t7}{t10}</label>;
    $[14] = t10;
    $[15] = t5;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-green-500" data-source="text">ON</span>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11) {
    t13 = <div className="my-4 flex items-center gap-x-1 text-xs">{t2}{t3}{t11}{t12}</div>;
    $[19] = t11;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = isEnglish ? "It is important to us that people with disabilities have access to a fair application process, providing them with an opportunity to shine. Therefore, our representative body for severely disabled people will be included in the process from an early stage. Please let us know via the application form if you require technical or organisational adjustments during the application process. We will strive to make the required aids available." : t.jobad_inclusion_text;
  let t15;
  if ($[21] !== source || $[22] !== t14) {
    t15 = <p data-source={source}>{t14}</p>;
    $[21] = source;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  const t16 = isEnglish ? "Should you not be able to apply online and want to speak someone in person, please contact your local recruiter" : t.jobad_inclusion_textSub;
  let t17;
  if ($[24] !== source || $[25] !== t16) {
    t17 = <p data-source={source}>{t16}</p>;
    $[24] = source;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t1 || $[28] !== t13 || $[29] !== t15 || $[30] !== t17) {
    t18 = <div>{t1}{t13}{t15}{t17}</div>;
    $[27] = t1;
    $[28] = t13;
    $[29] = t15;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  return t18;
}
function _temp(prev) {
  return !prev;
}
function DetailsBox(t0) {
  const $ = _c(56);
  const {
    data,
    showDeadline,
    deadline,
    salaryRow
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== t.jobad_details_HL) {
    t1 = <h3 className="mb-6 font-bold text-2xl" data-source="lc">{t.jobad_details_HL}:</h3>;
    $[0] = t.jobad_details_HL;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t.jobad_details_contractType) {
    t2 = <dt className="font-bold" data-source="lc">{t.jobad_details_contractType}:</dt>;
    $[2] = t.jobad_details_contractType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data.contract) {
    t3 = <dd data-source="job">{data.contract}</dd>;
    $[4] = data.contract;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t.jobad_details_employmentType) {
    t4 = <dt className="font-bold" data-source="lc">{t.jobad_details_employmentType}:</dt>;
    $[6] = t.jobad_details_employmentType;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== data.employmentType || $[9] !== t) {
    t5 = combineEmploymentTypes(data.employmentType, t);
    $[8] = data.employmentType;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <dd data-source="job">{t5}</dd>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t.jobad_details_remote) {
    t7 = <dt className="font-bold" data-source="lc">{t.jobad_details_remote}:</dt>;
    $[13] = t.jobad_details_remote;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== data.remote) {
    t8 = <dd data-source="job">{data.remote}</dd>;
    $[15] = data.remote;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t.jobad_details_company) {
    t9 = <dt className="font-bold" data-source="lc">{t.jobad_details_company}:</dt>;
    $[17] = t.jobad_details_company;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== data.company) {
    t10 = <dd data-source="job">{data.company}</dd>;
    $[19] = data.company;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t.jobad_details_jobNumber) {
    t11 = <dt className="font-bold" data-source="lc">{t.jobad_details_jobNumber}:</dt>;
    $[21] = t.jobad_details_jobNumber;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== data.jobNumber) {
    t12 = <dd data-source="job">{data.jobNumber}</dd>;
    $[23] = data.jobNumber;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== salaryRow) {
    t13 = salaryRow && <><dt className="font-bold" data-source="lc">{salaryRow.label}:</dt><dd data-source="job">{salaryRow.value}</dd></>;
    $[25] = salaryRow;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== deadline || $[28] !== showDeadline || $[29] !== t.jobad_details_applicationDeadlineTitle) {
    t14 = showDeadline && <><dt className="font-bold" data-source="lc">{t.jobad_details_applicationDeadlineTitle}:</dt><dd data-source="job">{deadline}</dd></>;
    $[27] = deadline;
    $[28] = showDeadline;
    $[29] = t.jobad_details_applicationDeadlineTitle;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t14 || $[36] !== t2 || $[37] !== t3 || $[38] !== t4 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8 || $[42] !== t9) {
    t15 = <dl className="mb-8 grid w-full grid-cols-2 gap-2 break-words md:w-2/3 lg:w-full">{t2}{t3}{t4}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}</dl>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t2;
    $[37] = t3;
    $[38] = t4;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== salaryRow || $[45] !== t.salary_info_text_additional) {
    t16 = salaryRow && <p data-source="lc">{t.salary_info_text_additional}</p>;
    $[44] = salaryRow;
    $[45] = t.salary_info_text_additional;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== showDeadline || $[48] !== t.jobad_details_applicationDeadline) {
    t17 = !showDeadline && <p data-source="lc">{t.jobad_details_applicationDeadline}</p>;
    $[47] = showDeadline;
    $[48] = t.jobad_details_applicationDeadline;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  let t18;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <PrivacyNotice className="mt-4" />;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t1 || $[52] !== t15 || $[53] !== t16 || $[54] !== t17) {
    t19 = <section className="my-10 bg-[#f6f6f7] p-10 text-foreground leading-6 lg:my-6">{t1}{t15}{t16}{t17}{t18}</section>;
    $[51] = t1;
    $[52] = t15;
    $[53] = t16;
    $[54] = t17;
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  return t19;
}